// ExpenseList.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ExpenseList.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClients } from '../../store/clientsSlice';
import { fetchExpenses, updateExpense, deleteExpense, fetchCatgories,addExpense } from '../../store/expenseSlice';

const ExpenseList = () => {
  const dispatch = useDispatch();
  const { categories, loading: categoriesLoading, error: categoriesError } = useSelector((state) => state.expenses);
  const { expenses, error } = useSelector((state) => state.expenses);
  const { clientId, financialYear } = useSelector((state) => state.app);

  const [editIndex, setEditIndex] = useState(null);
  const [editedExpense, setEditedExpense] = useState({ name: '', description: '', amount: '',category:'' });

  useEffect(() => {
    clientId.length > 0 && financialYear.length > 0 && dispatch(fetchClients()); // Ensure clients are loaded
    clientId.length > 0 && financialYear.length > 0 && dispatch(fetchExpenses({ clientId, financialYear }));
    dispatch(fetchCatgories());
  }, [dispatch, clientId, financialYear]);

  const handleEditClick = (index) => {
    setEditIndex(index);
    setEditedExpense({ ...expenses[index] });
  };
  const handleAddClick = (index) => {
    let obj={ ...expenses[index] };
    obj={...obj,amount:obj.draftAmount};
    
    dispatch(addExpense({...obj }))
    .unwrap()
      .then(() => {
        dispatch(fetchExpenses({ clientId, financialYear }));
        setEditIndex(null);
        setEditedExpense({ name: '', description: '', amount: '', category: '' });
      })
      .catch((err) => {
        console.error('Error Adding expense', err);
      });
  };

  const handleCancelEdit = () => {
    setEditIndex(null);
    setEditedExpense({ name: '', description: '', amount: '' });
  };

  const handleSaveEdit = (id) => {
    dispatch(updateExpense({ id, ...editedExpense }))
      .unwrap()
      .then(() => {
        dispatch(fetchExpenses({ clientId, financialYear }));
        setEditIndex(null);
        setEditedExpense({ name: '', description: '', amount: '' });
      })
      .catch((err) => {
        console.error('Error updating expense', err);
      });
  };

  const handleDelete = (id) => {
    dispatch(deleteExpense(id))
      .unwrap()
      .then(() => {
        dispatch(fetchExpenses({ clientId, financialYear }));
      })
      .catch((err) => {
        console.error('Error deleting expense', err);
      });
  };
  const handleKeyDown = (e, id) => {
    if (e.key === 'Enter') {
      handleSaveEdit(id);
    }
  };
  return (
    <div className="expense-list-page">
      <h2>Expense List</h2>
      <p className="financial-page-subtitle">Apply the same editing and table treatment across expense, income, and asset masters.</p>
      <div className="financial-toolbar">
        <Link to="/add-expense">
          <button className="add-expense-button">Add Expense</button>
        </Link>
      </div>
      {error && <p className="financial-message financial-message--error">{error}</p>}
      {expenses && expenses.length > 0 && (
        <div className="table-container">
          <table className="expense-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Financial Year</th>
                <th>Description</th>
                <th>Category</th>
                <th>Amount</th>
                <th>Draft Amount</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {expenses.map((expense, index) => (
                <tr key={expense.id}>
                  {editIndex === index ? (
                    <>
                      <td>
                        <input
                          type="text"
                          value={editedExpense.name}
                          onChange={(e) => setEditedExpense({ ...editedExpense, name: e.target.value })}
                          onKeyDown={(e) => handleKeyDown(e, expense.id)}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={editedExpense.financialYear}
                          onChange={(e) => setEditedExpense({ ...editedExpense, financialYear: e.target.value })}
                          onKeyDown={(e) => handleKeyDown(e, expense.id)}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={editedExpense.description}
                          onChange={(e) => setEditedExpense({ ...editedExpense, description: e.target.value })}
                          onKeyDown={(e) => handleKeyDown(e, expense.id)}
                        />
                      </td>
                      <td>
                        <select onChange={(e) => setEditedExpense({ ...editedExpense, category: e.target.value })} value={editedExpense.category}>
                          <option value="">Select Category</option>
                          {categoriesLoading ? (
                            <option>Loading...</option>
                          ) : categoriesError ? (
                            <option>Error loading Categories</option>
                          ) : (
                            categories.map(cat => (
                              <option key={cat} value={cat}>{cat}</option>
                            ))
                          )}
                        </select>

                      </td>
                      <td>
                        <input
                          type="number"
                          value={editedExpense.amount}
                          onChange={(e) => setEditedExpense({ ...editedExpense, amount: e.target.value })}
                          onKeyDown={(e) => handleKeyDown(e, expense.id)}
                          onDoubleClick={(e) => setEditedExpense({ ...editedExpense, amount: e.target.value })}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={editedExpense.draftAmount}
                          disabled
                        />
                      </td>
                      <td>
                        <button className="financial-button" onClick={() => handleSaveEdit(expense.id)}>Save</button>
                        <button className="financial-button financial-button--secondary" onClick={handleCancelEdit}>Cancel</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{expense.name}</td>
                      <td>{expense.financialYear}</td>
                      <td>{expense.description}</td>
                      <td>{expense.category}</td>
                      <td>{expense.amount}</td>
                      <td>{expense.draftAmount}</td>
                      <td>
                        {
                          expense.id && <>
                            <button className="financial-button financial-button--secondary" onClick={() => handleEditClick(index)}>Edit</button>
                            <button className="financial-button financial-button--danger" onClick={() => handleDelete(expense.id)}>Delete</button>
                          </>
                        }
                        {!expense.id && <>view only transaction. click to <button className="financial-button" onClick={() => handleAddClick(index)}>Add</button></>}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ExpenseList;
